import React from 'react';

interface Props {
  index: number;
  item: any;
  date: string;
}

function OrderList({ index, item, date }: Props) {
  return (
    <div
      key={index}
      className="border my-3 md:my-5 border-grey flex flex-col md:flex-row rounded-md p-2 md:p-5 "
    >
      <div className="flex items-center flex-[.7]  ">
        <div className="w-[100px] h-20">
          <img
            src={item.orderItem[0]?.image_url}
            className="w-full h-full object-cover rounded-md"
            alt={item.orderItem[0]?.item_name}
          />
        </div>
        <div className="ml-3">
          <p>{item.outletId.name}</p>
          <div className="text-sm flex items-center ">
            <p className="text-[#555]">{item?.orderItem?.length} Item</p>
            <p className="text-primary-400 ml-3">
              ₦{item?.totalAmount.toLocaleString()}
            </p>
          </div>
          <p className="text-[#ccc]">({date})</p>
        </div>
      </div>
      <div className="flex-1 md:flex-[.3]  flex  justify-between md:justify-end md:flex-col mt-3 md:mt-0">
        <a
          className="w-[48%] md:w-full text-sm"
          href={`/account/my-order/order-detail?trxref=${item?._id}`}
        >
          <div className="bg-primary-400 flex[.5]  text-white text-center rounded p-1 md:px-5 py-3 md:flex-1 md:w-full ">
            View Details
          </div>
        </a>

        <a href="tel:2348098242522" className="w-[48%] md:w-full">
          <div
            onClick={() => {}}
            className="border cursor-pointer  border-primary-400 text-center text-primary-400 p-2 rounded md:px-5 md:mt-3 py-2 "
          >
            Get Help
          </div>
        </a>
      </div>
    </div>
  );
}

export default OrderList;
